import * as React from 'react';
import { DetailsList, DetailsListLayoutMode, IColumn, Selection, SelectionMode, CheckboxVisibility } from '@fluentui/react/lib/DetailsList';
import { MarqueeSelection } from '@fluentui/react/lib/MarqueeSelection';
import { TextField } from '@fluentui/react/lib/TextField';
import { entityResultsScreen, summaryScreen, toggleLoading } from '../actions/navigationWorker';

export interface AppProps {
    hide: boolean;
    data: Array<JSON>;
}

export interface AppState {
    columns: IColumn[],
    selected: any,
    data: any,
    filterText: string
}

class ActiveTaskProperties extends React.Component<AppProps, AppState> {
    private _selection: Selection;

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => {
                const selectedTasks = this._getSelectionDetails();
                this.setState({
                    selected: selectedTasks
                });
                // Always save selection to sessionStorage, even if empty
                sessionStorage.setItem('selected_active_tasks', JSON.stringify(selectedTasks || []));
            }
        });

        this.state = {
            columns: this._getColumns(),
            selected: null,
            data: this.props.data,
            filterText: ''
        };
    }

    handleFilterChange = (_event, newValue: string) => {
        this.setState({ filterText: newValue || '' });
    }

    getFilteredTasks = () => {
        if (!this.state.filterText) {
            return this.props.data;
        }
        const filterLower = this.state.filterText.toLowerCase();
        return this.props.data.filter((task: any) => {
            return task.details && task.details.toLowerCase().includes(filterLower);
        });
    }

    back_to_results = () => {
        let results = JSON.parse(sessionStorage.getItem('search_results')) || [];
        entityResultsScreen(true, results);
    }

    private _getColumns(): IColumn[] {
        let columns = [];
        const fields = [{ field: 'details', header: 'Task Details', min: 100 }];

        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            let item_column = {
                key: 'col_' + field['field'],
                name: field['header'],
                fieldName: field['field'],
                minWidth: field['min'],
                isResizable: true,
                isMultiline: true
            };
            columns.push(item_column);
        }
        return columns;
    }

    private _getSelectionDetails(): any {
        const selected_items = this._selection.getSelection();
        const selected_tasks = [];

        if (selected_items !== null) {
            for (let i = 0; i < selected_items.length; i++) {
                let task_id = (selected_items[i] as any).id;
                let task_subject = (selected_items[i] as any).subject;
                let selected_task = { id: task_id, name: task_subject };
                selected_tasks.push(selected_task);
            }
        }
        return selected_tasks.length > 0 ? selected_tasks : null;
    }

    summary = () => {
        toggleLoading(true);
        const task_ids = this._getSelectionDetails();
        // Always save, even if empty array (task_ids will be null if nothing selected)
        sessionStorage.setItem('selected_active_tasks', JSON.stringify(task_ids || []));
        summaryScreen();
    }


    private _renderItemColumn(item: any, _: number, column: IColumn) {
        const fieldContent = item[column.fieldName || ''];
        const break_string = '|break|';
        if (column.key === 'col_details') {
            return fieldContent.split(break_string).map(t => <span key={t}>{t}<br /></span>);
        } else {
            return <span>{fieldContent}</span>;
        }
    }

    public render() {
        if (this.props.hide) {
            return (null);
        }
        toggleLoading(false);
        if (this.props.data.length === 0) {
            // Check if a client has been selected
            const selected_clients = JSON.parse(sessionStorage.getItem("selected_clients") || "[]");
            const hasSelectedClient = selected_clients && selected_clients.length > 0;
            
            return (
                <div style={{ fontSize: '13px' }}>
                    <div className='ms-u-textAlignCenter'>
                        <br /><br />
                        <div style={{ color: hasSelectedClient ? '#a4262c' : '#605e5c', fontSize: '13px', fontWeight: 500 }}>
                            {hasSelectedClient ? 'No Active tasks found' : 'Please select a client.'}
                        </div>
                    </div>
                </div>
            );
        }
        const filteredTasks = this.getFilteredTasks();
        return (
            <div style={{ fontSize: '13px' }}>
                <p style={{ marginBottom: '8px', fontSize: '13px', color: '#333' }}>Please select the active tasks that you would like to file the current email to:</p>
                <div style={{ marginBottom: '4px' }}>
                    <TextField
                        placeholder='Filter tasks...'
                        value={this.state.filterText}
                        onChange={this.handleFilterChange}
                        styles={{
                            root: { width: '100%' },
                            fieldGroup: { height: '32px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            field: { fontSize: '13px' }
                        }}
                    />
                </div>
                <div style={{ overflow: 'auto', maxHeight: '30vh', marginBottom: '8px' }} data-is-scrollable='true'>
                    <MarqueeSelection selection={this._selection}>
                        <DetailsList
                            items={filteredTasks}
                            columns={this._getColumns()}
                            setKey='set'
                            selectionMode={SelectionMode.multiple}
                            layoutMode={DetailsListLayoutMode.justified}
                            selectionPreservedOnEmptyClick={true}
                            enterModalSelectionOnTouch={true}
                            checkboxVisibility={CheckboxVisibility.always}
                            isHeaderVisible={true}
                            compact={true}
                            selection={this._selection}
                            onRenderItemColumn={this._renderItemColumn}
                        />
                    </MarqueeSelection>
                </div>
            </div>
        );
    }
}

export default ActiveTaskProperties;
